module.exports = __webpack_public_path__ + "media/images/logos/WS_illustration-site-vitrine-2022-35-6b000b90c4a02fc632af8599b8f2e1db.svg";